<script setup>
import { computed, provide } from 'vue'

const props = defineProps({
  columns: { type: Array, required: true },
})

provide('reportTableColspan', computed(() => props.columns.length))
</script>

<template lang="pug">
table.table.table-lg.no-borders
  tbody
    slot
  tfoot
    slot(name="footer" :colspan="columns.length")
</template>
